import PropTypes from 'prop-types';
import { BsClockHistory } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';
import Tag from '#globalComponents/Tag/Tag';

const EVENT_TYPE_LABELS = {
	AddressChange: 'Adressänderung',
	CapitalChange: 'Kapitaländerung',
	ContractChange: 'Vertragsänderung',
	ControlChange: 'Kontrollwechsel',
	Continuation: 'Fortführung',
	Funding: 'Förderung',
	Insolvency: 'Insolvenz',
	InsolvencyChange: 'Insolvenzänderung',
	JobPosting: 'Stellenanzeige',
	LegalFormChange: 'Rechtsformwechsel',
	LeiDate: 'LEI-Datum',
	Liquidation: 'Liquidation',
	ManagementChange: 'Personaländerung',
	MergerOrAcquisition: 'Fusion/Übernahme',
	NameChange: 'Umfirmierung',
	NewCompany: 'Neugründung',
	Patent: 'Patent',
	RegisterChange: 'Registeränderung',
	Restoration: 'Wiedereintragung',
	StatutoryChange: 'Satzungsänderung',
	Termination: 'Löschung',
	Trademark: 'Marke',
	YearlyReport: 'Jahresbericht',
};

const EVENT_TYPE_TONES = {
	Insolvency: 'warning',
	Liquidation: 'warning',
	Termination: 'warning',
	NewCompany: 'success',
	CapitalChange: 'success',
	Funding: 'primary',
	NameChange: 'primary',
	ManagementChange: 'caution',
	JobPosting: 'success',
};

// A job ad event carries the advertised occupation (the job board's name for it) as its description.
const describeEvent = (event) => {
	if (event.eventType !== 'JobPosting' || !event.description) return event.description;
	return `Beruf: ${event.description}`;
};

const CompanyEventsTimeline = ({ events }) => (
	<SectionCard title="Historie" icon={BsClockHistory}>
		<ol className="relative space-y-4 before:absolute before:bottom-0 before:left-[5px] before:top-1 before:w-px before:bg-bgBase-500">
			{events.map((event) => {
				const date = event.eventDate ? new Date(event.eventDate).toLocaleDateString('de-DE') : null;
				const description = describeEvent(event);

				return (
					<li key={event.id} className="relative pl-6">
						<span className="absolute left-0 top-1 h-[11px] w-[11px] rounded-full border-2 border-primary-500 bg-white" />
						<div className="flex flex-wrap items-center gap-2">
							<Tag
								label={EVENT_TYPE_LABELS[event.eventType] || event.eventType}
								tone={EVENT_TYPE_TONES[event.eventType] || 'neutral'}
							/>
							{date && <span className="text-xs text-bgBase-800">{date}</span>}
						</div>
						{description && <p className="mt-1 text-sm text-text">{description}</p>}
					</li>
				);
			})}
		</ol>
	</SectionCard>
);

CompanyEventsTimeline.propTypes = {
	events: PropTypes.array.isRequired,
};

export default CompanyEventsTimeline;
